<template>
  <div
    class="alert-condition-card"
    :class="excludeActive?color:''"
  >
    <div class="card-container">
      <i
        class="leading-icon icon-alert-filled"
        :class="color"
      />
      <div class="card-content">
        <WsText001 bold>
          {{ text }}
        </WsText001>
        <div class="content-list">
          <WsFlex>
            <WsText001 h6>
              {{ $t('發布時間') }}
            </WsText001>
            <WsText001
              h6
              class="ml-8"
            >
              {{ launchAt }}
            </WsText001>
          </WsFlex>
          <WsFlex
            v-if="excludeAt"
            class="list-item"
          >
            <WsText001 h6>
              {{ $t('排除時間') }}
            </WsText001>
            <WsText001
              h6
              class="ml-8"
            >
              {{ excludeAt }}
            </WsText001>
            <LlAvatar
              :text-label="avatar.name"
              :image="avatar.avatar"
              class="ml-6"
            />
          </WsFlex>
        </div>
      </div>
    </div>
    <div
      v-if="displayBtn"
      class="btns"
    >
      <div
        v-if="excludeActive"
        class="btn"
      >
        <ChipButton
          :color="color"
          :text-label="$t('排除警示')"
          icon="icon-alert-cancel"
          @click="$_btnclick()"
        />
      </div>
      <div
        v-if="!excludeActive"
        class="btn"
      >
        <ChipButton
          color="gray"
          :text-label="$t('復原警示')"
          icon="icon-nav-alert-filled"
          @click="$_btnclick()"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AlertConditionCard",
  props: {
    color: {
      type: String,
      default: "",
    },
    excludeActive: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "",
    },
    launchAt: {
      type: String,
      default: "",
    },
    excludeAt: {
      type: String,
      default: "",
    },
    avatar: {
      type: Object,
      default() {
        return {};
      },
    },
    displayBtn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    $_btnclick() {
      this.$emit("btn-click");
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/alert-condition-card";
</style>